import moment from 'moment';
import Tracking from './Tracking';

export const isServer = typeof window === 'undefined';

export function isPDF(file) { // eslint-disable-line
	const extension = file.split('.').pop();
	return extension === 'pdf';
}

export function jobExpired(date) {
	return moment(date).isBefore();
}

export function trackClick(event) {
	Tracking.eventTrack('button click', {
		button: event.target.innerText,
		location: window.location.pathname,
	});
}

/**
 * Used to parse Contentful Image object
 * @param data
 * @param defaultData {Object}
 * @return {{}|undefined}
 */
export function parseContentfulImageItem(data, defaultData = undefined) {
	const image = {};
	// if there is not image or image isn't from contentfull return default image
	if (!data || !data.file || !data.localFile) {
		if (defaultData) {
			return defaultData;
		}
		return undefined;
	}

	image.width = data.file?.details.image.width;
	image.height = data.file?.details.image.height;

	image.localFile = data.localFile;
	image.title = data.title;

	image.description = data.description;

	image.src = `${process.env.PUBLIC_URL}${data.localFile.publicURL}`;

	return image;
}

export const SOUND_EFFECTS = {
	ROLL_DICE: 'rollDiceAudioPlayer',
	NUDGE: 'nudgeAudioPlayer',
	WRITE: 'writeAudioPlayer',
	OPPONENT_JOINED: 'opponentJoined',
};

export function playSound(effectId) {
	const audio = document.getElementById(effectId);
	if (effectId === SOUND_EFFECTS.WRITE) {
		audio.volume = 0.2;
	}
	if (audio.paused) {
		audio.play().catch((e) => {});
	} else {
		audio.pause();
		audio.currentTime = 0;
		audio.play().catch((e) => {});
	}
}

export const enterFullScreen = (element) => {
	if (element.requestFullscreen) {
		element.requestFullscreen();
	} else if (element.mozRequestFullScreen) { /* Firefox */
		element.mozRequestFullScreen();
	} else if (element.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
		element.webkitRequestFullscreen();
	} else if (element.msRequestFullscreen) { /* IE/Edge */
		element.msRequestFullscreen();
	}
};

export const closeFullScreen = () => {
	if (document.exitFullscreen) {
		document.exitFullscreen();
	} else if (document.mozCancelFullScreen) { /* Firefox */
		document.mozCancelFullScreen();
	} else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
		document.webkitExitFullscreen();
	} else if (document.msExitFullscreen) { /* IE/Edge */
		document.msExitFullscreen();
	}
};

export function flashTitle(pageTitle, newMessageTitle) {
	if (document.title === pageTitle) {
		document.title = newMessageTitle;
	} else {
		document.title = pageTitle;
	}
}
export const isSafari = !isServer && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

/**
 *
 * @param {string} value - copy value
 */
export function copyCommand(value) {
	const el = document.createElement('textarea');
	el.value = value;
	document.body.appendChild(el);
	el.select();
	document.execCommand('copy');
	document.body.removeChild(el);
}
export const isDesktopSafari = () => {
	const uA = navigator.userAgent;
	const { vendor } = navigator;
	return /Safari/i.test(uA) && /Apple Computer/.test(vendor) && !/Mobi|Android/i.test(uA);
};
